import request from '@/utils/request'

export function queryArrearsContractNew(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/contract.queryArrearsContractNewCmd',
            method: 'post',
            data
        }).then(response => {
            const res = response.data
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}